import {FormValidator} from "../../../tools/form/form-validator";
import {isEmptyString} from "../../validations";
import {DoctorFindings} from "../analysis";

export class SleepAnalysisValidator extends FormValidator<DoctorFindings> {
  constructor(doctorFindings: DoctorFindings) {
    super(new Map([
      ["findings", () => !isEmptyString(doctorFindings.findings ?? "")],
      ["conclusion", () => !isEmptyString(doctorFindings.conclusion ?? "")]
    ]));
  }
}
